import type { TDispatcher } from '../types/shipment'

/**
 * Gets the carrier workspace ID from the dispatchers array
 * Dispatchers are from the carrier workspace, so we can use their workspace ID
 * @param dispatchers - The dispatchers array from shipment
 * @returns The carrier workspace ID or null if no dispatcher found
 */
export function getCarrierWorkspaceIDFromDispatchers(dispatchers?: TDispatcher[]): string | null {
  if (!dispatchers || dispatchers.length === 0) {
    return null
  }

  // Get the first dispatcher's workspace ID (assuming all dispatchers are from the same carrier workspace)
  const dispatcher = dispatchers.find((d) => d && d.workspace?.id)
  return dispatcher?.workspace?.id || null
}
